import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import "./form-validation";
import "./gallery";
import "./leaflet";
import "./map"

const nav = document.getElementById("main-menu");
const openClass = "c-navigation--open";
const closeClass = "c-navigation--close";
const MOBILE_NAV_MQ = window.matchMedia("(max-width: 768px)");
const scrollLockOptions = {
  allowTouchMove: (el) =>
    !!el.closest(
      ".c-navigation__navlist--wrapper-mobile, .c-navigation__navlist, .c-lang-switcher, .c-navigation__contents--top"
    ),
};

var focusableEls = nav.querySelectorAll('a[href]:not([disabled]), button:not([disabled])');
var firstFocusableEl = focusableEls[1];  // 1 as 0 is the skip to content button
var lastFocusableEl = focusableEls[focusableEls.length - 1];
var KEYCODE_TAB = 9;

const langSwitchers = document.querySelectorAll(".c-lang-switcher");

const isMobileMenuOpen = () =>
  MOBILE_NAV_MQ.matches && nav && nav.classList.contains(openClass);

const syncMobileLangSwitcher = () => {
  langSwitchers.forEach((switcher) => {
    const langToggle = switcher.querySelector(".c-lang-switcher__toggle");
    const langMenu = switcher.querySelector(".c-lang-switcher__menu");
    if (!langToggle || !langMenu) return;

    if (isMobileMenuOpen()) {
      langToggle.hidden = true;
      langMenu.hidden = false;
      langToggle.setAttribute("aria-expanded", "false");
      return;
    }

    langToggle.hidden = false;
    langMenu.hidden = true;
    langToggle.setAttribute("aria-expanded", "false");
  });
};

const swapOpenState = () => {
  if (!nav) return;
  if (nav.classList.contains(openClass)) {
    nav.classList.remove(openClass);
    nav.classList.add(closeClass);
    nav.removeEventListener('keydown', trapFocus)
    enableBodyScroll(document.body);
  } else {
    nav.classList.add(openClass);
    nav.classList.remove(closeClass);
    nav.addEventListener('keydown', trapFocus)
    disableBodyScroll(document.body, scrollLockOptions);
  }
  syncMobileLangSwitcher();
};

function trapFocus(e) {
  console.log(e)
    var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    if (!isTabPressed) { 
      return; 
    }

    if ( e.shiftKey ) /* shift + tab */ {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
          e.preventDefault();
        }
    } else /* tab */ {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
          e.preventDefault();
        }
      }
}

const mainMenuToggle = document.getElementById("main-menu-toggle");
mainMenuToggle.addEventListener("click", swapOpenState);

let resizeTimeout;

const debounce = (func, delay) => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(func, delay);
};

// Check if on desktop view
const checkViewportSize = () => {
  if (window.innerWidth >= 769) {
    enableBodyScroll(document.getElementById("main-menu"));
    nav.classList.remove(closeClass);
    nav.classList.remove(openClass);
  }
  syncMobileLangSwitcher();
};

window.addEventListener("resize", () => debounce(checkViewportSize, 600));
checkViewportSize(); // Trigger on initial page load

if (MOBILE_NAV_MQ.addEventListener) {
  MOBILE_NAV_MQ.addEventListener("change", syncMobileLangSwitcher);
} else {
  MOBILE_NAV_MQ.addListener(syncMobileLangSwitcher);
}



// check header height
function checkHeaderHeight() {
  // select header element
  const header = document.querySelector('.c-navigation');
  // get rendered styles
  const styles = window.getComputedStyle(header);
  // set header height rendered style
  const headerHeight = styles.height;
  // set CSS as a value
  document.documentElement.style.setProperty("--nav-height", headerHeight);
}
addEventListener("resize", checkHeaderHeight);
addEventListener("orientationchange", checkHeaderHeight);
checkHeaderHeight();


const closeAllLangMenus = (exceptSwitcher = null) => {
  if (isMobileMenuOpen()) return;

  langSwitchers.forEach((switcher) => {
    if (switcher === exceptSwitcher) return;
    const langToggle = switcher.querySelector(".c-lang-switcher__toggle");
    const langMenu = switcher.querySelector(".c-lang-switcher__menu");
    if (!langToggle || !langMenu) return;
    langMenu.hidden = true;
    langToggle.setAttribute("aria-expanded", "false");
  });
};

langSwitchers.forEach((switcher) => {
  const langToggle = switcher.querySelector(".c-lang-switcher__toggle");
  const langMenu = switcher.querySelector(".c-lang-switcher__menu");

  if (!langToggle || !langMenu) return;

  langToggle.addEventListener("click", (event) => {
    if (isMobileMenuOpen()) return;

    event.preventDefault();
    event.stopPropagation();

    const willOpen = langMenu.hidden;
    closeAllLangMenus(willOpen ? switcher : null);
    langMenu.hidden = !willOpen;
    langToggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
  });
});

document.addEventListener("click", (event) => {
  if (isMobileMenuOpen()) return;

  langSwitchers.forEach((switcher) => {
    if (switcher.contains(event.target)) return;

    const langToggle = switcher.querySelector(".c-lang-switcher__toggle");
    const langMenu = switcher.querySelector(".c-lang-switcher__menu");
    if (!langToggle || !langMenu || langMenu.hidden) return;

    langMenu.hidden = true;
    langToggle.setAttribute("aria-expanded", "false");
  });
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeAllLangMenus();
  }
});

syncMobileLangSwitcher();


if (window.location.href.match('https://sanis.nl/whatsapp/') != null || window.location.href.match('/whatsapp') != null) {
  window.onload = function() {       
    setTimeout(function(){
      console.log("You are being redirected to the whatsapp chat")
      window.location.replace("https://wa.me/31633031780");
    },3000); 
}
};